module.exports = __webpack_public_path__ + "img/pengaturan-icon.9ba2f28e.svg";